const l = (t, e, r) => {
  const o = [...t];
  return o[e] = r, Array.from(o);
}, d = (t, e, r, o) => `${Math.round((e - t) / (o - r) * 100)}%`, S = (t, e, r) => {
  if (t < e || t > r)
    throw new Error(
      `Value should be between ${e} and ${r} (${t} given)`
    );
  return d(e, t, e, r);
}, h = (t, e, r, o) => {
  const c = Math.floor((r - e) / o);
  let n = Math.round((t - e) / o);
  return n = Math.max(0, n), n = Math.min(c, n), n * o + e;
}, i = (t, e, r, o, s, c) => {
  const { clientX: n } = "touches" in t ? t.touches[0] : t, u = (n - e) / r * (s - o) + o;
  return h(u, o, s, c);
};
export {
  h as getClosestStep,
  S as getTrackPosition,
  d as getTrackSize,
  i as getTrackValue,
  l as getUpdatedValue
};
